"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { getReplies } from "@/queries-alt/with-use-server";
import { useAuth } from "@clerk/nextjs";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Loader } from "lucide-react";
import ReplyItem from "./reply-item";
type ReplyListProps = {
  parentCommentId: string;
};
export default function ReplyList(t0) {
  const $ = _c(22);
  const {
    parentCommentId
  } = t0;
  const {
    userId
  } = useAuth();
  const t1 = `get-replies:${parentCommentId}`;
  let t2;
  if ($[0] !== t1) {
    t2 = [t1];
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== parentCommentId || $[3] !== userId) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      return await getReplies({
        parentCommentId,
        page: pageParam,
        userId
      });
    };
    $[2] = parentCommentId;
    $[3] = userId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3,
      initialPageParam: 1,
      getNextPageParam: _temp
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    data,
    status,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage
  } = useInfiniteQuery(t4);
  if (status === "pending") {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Loader className="animate-spin" />;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t5;
  let t6;
  if ($[9] !== data?.pages) {
    const replies = data?.pages.flatMap(_temp2) || [];
    t6 = "flex max-h-96 w-full flex-col overflow-auto";
    t5 = replies.map(_temp3);
    $[9] = data?.pages;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <ul>{t5}</ul>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== fetchNextPage || $[15] !== hasNextPage || $[16] !== isFetchingNextPage) {
    t8 = hasNextPage && <Button variant="outline" disabled={isFetchingNextPage} onClick={() => fetchNextPage()} className="shrink-0">{isFetchingNextPage ? "Loading more..." : "Load more"}</Button>;
    $[14] = fetchNextPage;
    $[15] = hasNextPage;
    $[16] = isFetchingNextPage;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp3(reply) {
  return <ReplyItem key={reply.id} reply={reply} />;
}
function _temp2(page) {
  return page.replies;
}
function _temp(lastPage) {
  return lastPage.pagination.hasMore ? lastPage.pagination.page + 1 : undefined;
}